interface Props {
  /** Hauteur du cœur, en pixels. Le mot suit proportionnellement. */
  taille?: number;
  /** Sans le mot : pour un en-tete ou une barre, ou la place manque. */
  marqueSeule?: boolean;
}

/**
 * Le logo : un cœur fendu en deux, la moitie rose (Yuwei) et la moitie bleue
 * (Jordan) — les memes couleurs que les pastilles a cote de vos prenoms dans
 * les listes.
 *
 * En SVG et non en image : net a toutes les tailles, quelques centaines
 * d octets, et les couleurs suivent les jetons du theme clair comme du theme
 * sombre. C est ici que le mot « CamEllie » a sa place, pas dans l icone de
 * l ecran d accueil — a 60 pt iOS ecrit deja le nom sous l icone, et un texte
 * a cette taille ne serait qu une tache.
 */
export function Logo({ taille = 72, marqueSeule = false }: Props) {
  const largeur = taille * (32 / 29);

  return (
    <div className="logo" aria-label="CamEllie">
      <svg
        viewBox="0 0 32 29"
        width={largeur}
        height={taille}
        role="img"
        aria-hidden="true"
        focusable="false"
      >
        <defs>
          {/* Le cœur est trace une seule fois, puis peint deux fois a travers
              deux fenetres qui laissent une fente au milieu. */}
          <path
            id="camellie-coeur"
            d="M16 29C16 29 0 18.5 0 9.5C0 4.25 4.25 0 9.5 0C13 0 16 2 16 5C16 2 19 0 22.5 0C27.75 0 32 4.25 32 9.5C32 18.5 16 29 16 29Z"
          />
          <clipPath id="camellie-gauche">
            <rect x="0" y="0" width="15.2" height="29" />
          </clipPath>
          <clipPath id="camellie-droite">
            <rect x="16.8" y="0" width="15.2" height="29" />
          </clipPath>
        </defs>

        <use href="#camellie-coeur" clipPath="url(#camellie-gauche)" fill="var(--rose)" />
        <use href="#camellie-coeur" clipPath="url(#camellie-droite)" fill="var(--accent)" />
      </svg>

      {!marqueSeule && (
        <span className="logo-mot" style={{ fontSize: taille * 0.42 }}>
          CamEllie
        </span>
      )}
    </div>
  );
}
